import { Box, Button, TextField } from "@material-ui/core";
import { NodeModel } from "@minoru/react-dnd-treeview";
import React, { useState } from "react";
import { ErrorModal } from "../../../../../../../../../components/modals/error-modal";
import MesfModal from "../../../../../../../../../components/modals/modal.mesf";
import { ButtonWithLoading } from "../../../../../../../../../components/shared/buttons/button-with-loading";
import { TagFromTree } from "../../../../../models/TagsTree.model";
import { upsertTagFolder } from "../../../../../repository/TrendingRepository";

interface Props {
	open: boolean;
	handleClose: (shouldUpdate: boolean) => void;
	tagNodeSelectedInTree: NodeModel<TagFromTree> | null;
}
export const NewFolderModal = ({
	open,
	handleClose,
	tagNodeSelectedInTree,
}: Props) => {
	const [name, setName] = useState<string>();
	const [error, setError] = useState<string>("");
	const [isLoading, setIsLoading] = useState<boolean>(false);

	const onSubmit = async (e: any) => {
		e.preventDefault();

		const parentId = Number(tagNodeSelectedInTree?.parent) || null;
		const parentTagId =
			tagNodeSelectedInTree?.data?.TagTypeCode === "F"
				? Number(tagNodeSelectedInTree.id)
				: parentId;

		setIsLoading(true);
		if (name) {
			const resp = await upsertTagFolder(null, parentTagId, name, true);
			if (!resp.ok) {
				setError(resp.message);
			}
		}

		handleClose(true);
		setName("");
		setIsLoading(false);
	};

	return (
		<>
			<MesfModal
				open={open}
				handleClose={() => handleClose(false)}
				maxWidth={"lg"}
				aria-labelledby="modal-modal-title"
				aria-describedby="modal-modal-description"
				title="New folder"
			>
				<MesfModal.Content>
					<Box>
						<TextField
							style={{ minWidth: "600px" }}
							id="outlined-basic"
							label="Folder name"
							variant="outlined"
							value={name}
							onChange={(e) => setName(e.target.value)}
						/>
					</Box>
				</MesfModal.Content>
				<MesfModal.Actions>
					<div>
						<Button
							color="secondary"
							variant="outlined"
							onClick={() => handleClose(false)}
						>
							Cancel
						</Button>
					</div>
					<div>
						<ButtonWithLoading
							isLoading={isLoading}
							onClick={onSubmit}
							color="primary"
							variant="contained"
						>
							Save
						</ButtonWithLoading>
					</div>
				</MesfModal.Actions>
			</MesfModal>
			<ErrorModal error={error} onHide={() => setError("")} />
		</>
	);
};
